module.exports = __webpack_public_path__ + "img/gigis.9a9a813c.jpg";